import { EVENT_CONFIGS_API_URL, APP_DOMAIN } from 'appenv';
import axios from 'axios';
import { Auditorium } from 'models/auditoriums/types';

const fetchAuditoriumByWebinarId = async (webinarId: string): Promise<Auditorium | null> => {
  try {
    const fetchAuditoriumUrl = `${EVENT_CONFIGS_API_URL}/${APP_DOMAIN}/webinars/${webinarId}/auditorium`;
    const fetchAuditoriumResponse = await axios.get(fetchAuditoriumUrl);
    return fetchAuditoriumResponse.data as Auditorium;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export default fetchAuditoriumByWebinarId;
